var React = require('react');

function ShareAltRegular (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m352 320c-25.6 0-48.9 10-66.1 26.4l-98.3-61.5c5.9-18.8 5.9-39.1 0-57.8l98.3-61.5c17.2 16.4 40.5 26.4 66.1 26.4 53 0 96-43 96-96s-43-96-96-96-96 43-96 96c0 9.8 1.5 19.6 4.4 28.9l-98.3 61.5c-17.2-16.4-40.5-26.4-66.1-26.4-53 0-96 43-96 96s43 96 96 96c25.6 0 48.9-10 66.1-26.4l98.3 61.5c-2.9 9.4-4.4 19.1-4.4 28.9 0 53 43 96 96 96s96-43 96-96-43-96-96-96zm0-272c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm-256 256c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm256 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"}));
}

ShareAltRegular.defaultProps = {"viewBox":"0 0 448 512"};

module.exports = ShareAltRegular;

ShareAltRegular.default = ShareAltRegular;
